import { UTCDeliveryPeriod } from '@epicuro-next/ataraxia/models';
import { ExtendedBasketAccountAddress } from '@epicuro-next/state/basket-state';
import { getDeliveryShopId, isDatesEqualInUTC } from '@epicuro-next/utilities';
import { OrderType } from 'graphql-api/gql-api-interfaces';

import { isTrustedDeliveryPeriod } from '../../../../actions';
import { BusinessState, UiState } from '../../../../models';
import { updateDeliveryPeriodsCacheReducer } from '../../cache-delivery-periods/update-delivery-periods-cache.reducer';
import { addFutureDeliveryPeriodReducerNew } from '../add-future-delivery-period.reducer';

/** deprecated, use only addFutureDeliveryPeriodReducerNew */
export const addFutureDeliveryPeriodBusiness = (
  state: BusinessState,
  deliveryPeriod: UTCDeliveryPeriod & isTrustedDeliveryPeriod,
  cacheNewDate: boolean,
  deliveryShops: ExtendedBasketAccountAddress[],
): BusinessState => {
  const deliveryShopId = getDeliveryShopId(state.activeDeliveryShop);
  const currentPeriods = state.deliveryItems[deliveryShopId] ?? {};
  const deliveryPeriodId = deliveryPeriod.from;
  const exists = Object.keys(currentPeriods).find((existingPeriod) =>
    isDatesEqualInUTC(existingPeriod, deliveryPeriodId),
  );

  if (!exists) {
    const fromDate = deliveryPeriod.from;
    return {
      ...state,
      ...addFutureDeliveryPeriodReducerNew(
        state,
        deliveryPeriod,
        deliveryShops,
      ),
      deliveryItems: {
        ...state.deliveryItems,
        [deliveryShopId]: {
          ...currentPeriods,
          [deliveryPeriodId]: {
            // All the periods added here are for Future. NOW is created from the beginning if it's available.
            orderType: OrderType.Future,
            items: {},
          },
        },
      },
      cached: cacheNewDate
        ? updateDeliveryPeriodsCacheReducer(state.cached, fromDate)
        : state.cached,
    };
  }

  return {
    ...addFutureDeliveryPeriodReducerNew(state, deliveryPeriod, deliveryShops),
  };
};

/** deprecated, use only addFutureDeliveryPeriodReducerNew */
export const addFutureDeliveryPeriodUi = (
  state: UiState,
  deliveryPeriod: UTCDeliveryPeriod & isTrustedDeliveryPeriod,
): UiState => {
  return {
    ...state,
    // if user changed then change orderType, otherwise do not
    selectedOrderType: !!deliveryPeriod.isTrusted
      ? OrderType.Future
      : state.selectedOrderType,
  };
};
